(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return; // disable zoom on mobile/tablet
  }

  var mediaElements = document.querySelectorAll('.product-media');

  mediaElements.forEach(function (media) {
    var img = media.querySelector('img');
    if (!img) return;

    var zoomScale = 1.3;

    media.addEventListener('mouseenter', function () {
      img.style.transform = 'scale(' + zoomScale + ')';
    });

    media.addEventListener('mousemove', function (e) {
      var rect = media.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });

    media.addEventListener('mouseleave', function () {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
